export function loading (store) {
  return {
    install: function (Vue) {
      Vue.mixin({
        beforeCreate () {
          if (store.state.loadingError) store.commit('setLoadingError', false)
        }
      })

      Vue.prototype.$loading = {
        start () {
          store.commit('setLoading', true)
        },
        fail () {
          store.commit('setLoadingError', true)
        },
        done () {
          store.commit('setLoading', false)
        }
      }
    }
  }
}
